import React from 'react';
import { ClockIcon, ImageOffIcon, RocketIcon, GaugeIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const pains = [{
  icon: ClockIcon,
  text: 'Pasan 4 horas redactando un anuncio que Meta termina rechazando.'
}, {
  icon: ImageOffIcon,
  text: 'Gastan cientos de dólares en bancos de imágenes que todo el mundo usa.'
}, {
  icon: RocketIcon,
  text: 'Tienen ideas de productos increíbles que nunca lanzan porque "no saben cómo estructurarlas".'
}];
export function PainAgitation() {
  return <section className="relative w-full bg-ink-950 py-10 sm:py-16" data-id="element-192">
      <div className="mx-auto max-w-4xl px-5" data-id="element-193">
        <SectionHeading eyebrow="La Parálisis" data-id="element-194">
          La mayoría está atrapada en el{' '}
          <span className="text-urgency" data-id="element-195">"Bucle de la Parálisis Creativa"</span>
        </SectionHeading>

        <ul className="mt-10 space-y-4" data-id="element-196">
          {pains.map((pain, i) => <Reveal as="li" key={pain.text} delay={i * 0.1} data-id="element-197">
              <div className="flex items-start gap-4 rounded-2xl border border-white/5 bg-ink-800/50 p-5 transition-colors hover:border-urgency/30" data-id="element-198">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-urgency/10 text-urgency ring-1 ring-urgency/30" data-id="element-199">
                  <pain.icon className="h-5 w-5" aria-hidden="true" data-id="element-200" />
                </span>
                <p className="pt-1.5 text-sm text-silver/80 sm:text-base" data-id="element-201">
                  {pain.text}
                </p>
              </div>
            </Reveal>)}
        </ul>

        <Reveal delay={0.3} data-id="element-202">
          <div className="mt-8 rounded-3xl border border-accent/20 bg-gradient-to-br from-ink-800 to-ink-900 p-8 text-center shadow-card" data-id="element-203">
            <GaugeIcon className="mx-auto h-9 w-9 text-accent" aria-hidden="true" data-id="element-204" />
            <p className="mt-4 text-base text-silver/80 sm:text-lg" data-id="element-205">
              Cada hora que pasas peleando con un prompt es una hora que{' '}
              <span className="font-semibold text-white" data-id="element-206">
                no estás facturando
              </span>
              . En 2026, la diferencia entre los que dominan el mercado y los
              que desaparecen es una sola:
            </p>
            <p className="mt-4 font-display text-3xl uppercase tracking-tight text-cyan-gradient sm:text-4xl" data-id="element-207">
              Velocidad de ejecución
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}